import React, { FC, useState } from 'react';
import { IOption, Select } from '@components/UIKit/Select/Select';
import { useRouter } from 'next/router';
import { PageQueries, replaceQuery } from '@specs/navigation';
import { translateType, useTranslation } from '@hooks/useTranslation';
interface Props {}
type selectItemType = IOption<string, NonNullable<PageQueries['profilePageFilter']>>;
const getList = (tr: translateType): selectItemType[] => [{
  label: tr({
    id: 'public.profile.filter.all'
  }),
  value: 'all'
}, {
  label: tr({
    id: 'public.profile.filter.created'
  }),
  value: 'created'
}, {
  label: tr({
    id: 'public.profile.filter.collected'
  }),
  value: 'collected'
}, {
  label: tr({
    id: 'public.profile.filter.on.sale'
  }),
  value: 'on_sale'
}, {
  label: tr({
    id: 'public.profile.filter.under.moderation'
  }),
  value: 'under_moderation'
}];
export const FilterSelect: FC<Props> = ({}) => {
  const {
    translate: tr
  } = useTranslation();
  const router = useRouter();
  const {
    profilePageFilter
  }: PageQueries = router.query;
  const optionsList = getList(tr);
  const [value, setValue] = useState(optionsList.find(({
    value
  }) => value === profilePageFilter));
  const changeHandler = async (option: selectItemType) => {
    const isAll = option.value === 'all';
    setValue(isAll ? undefined : option);
    await replaceQuery(router, {
      profilePageFilter: option.value
    });
  };
  return <Select changeHandler={changeHandler} options={optionsList} value={typeof value === 'undefined' ? optionsList[0] : value} data-sentry-element="Select" data-sentry-component="FilterSelect" data-sentry-source-file="FilterSelect.tsx" />;
};